<template>
  <div class="app-container">
    <transition name="el-zoom-in-top">
      <el-card v-show="!editStatus" class="custom-card mb-20" shadow="never">
        <el-button v-if="calcPermission(permition, 1)" class="filter-item" round type="danger" icon="el-icon-circle-plus-outline" @click="handleCreate">{{ $t('table.add') }}</el-button>
      </el-card>
    </transition>
    <transition name="el-zoom-in-top">
      <div v-show="!editStatus" class="filter-container">
        <el-table
          v-loading="listLoading"
          :key="tableKey"
          :data="list"
          fit
          stripe
          highlight-current-row
          style="width: 100%;">
          <el-table-column
            type="index"
            width="100"
            align="center" />
          <el-table-column :label="$t('table.number')" width="200px" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.SStatusNo">{{ scope.row.SStatusNo }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.name')" width="200px" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.SName">{{ scope.row.SName }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.entityName')" min-width="100%" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.SModleName">{{ scope.row.SModleName }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.remarks')" align="center" width="200px">
            <template slot-scope="scope">
              <span v-if="scope.row.SMemo">{{ scope.row.SMemo }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.actions')" align="center" width="230" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-link v-if="calcPermission(permition, 2)" class="custom-link" type="primary" size="mini" @click="handleUpdate(scope.row)">{{ $t('table.edit') }}</el-link>
              <el-link v-if="calcPermission(permition, 3)" class="custom-link" size="mini" type="danger" @click="handleDelete(scope.row)">{{ $t('table.delete') }}</el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-card class="custom-card" shadow="never">
          <el-pagination v-show="total>0" :current-page="listQuery.pageIndex" :page-sizes="[10,20,50,100]" :page-size="listQuery.pageSize" :total="total" layout="total, prev, pager, next" @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
        </el-card>
      </div>
    </transition>
    <!-- 编辑/新增 -->
    <transition name="el-zoom-in-bottom">
      <div v-show="editStatus" class="filter-container">
        <el-card class="custom-card" shadow="never">
          <el-row :gutter="10">
            <el-col class="CommitForm">
              <el-form v-if="commitFrom" ref="commitFrom" :rules="rules" :model="commitFrom" label-position="right" label-width="100px">
                <el-form-item :label="$t('table.number')" prop="SStatusNo">
                  <el-input v-model="commitFrom.SStatusNo" class="filter-item" placeholder="请输入编号" />
                </el-form-item>
                <el-form-item :label="$t(`table.name`)" prop="SName">
                  <el-input v-model="commitFrom.SName" class="filter-item" placeholder="请输入名称" />
                </el-form-item>
                <el-form-item :label="$t(`table.entityName`)" prop="SModleName">
                  <el-input v-model="commitFrom.SModleName" class="filter-item" placeholder="请输入实体名称" />
                </el-form-item>
                <el-form-item :label="$t(`table.sort`)">
                  <el-input v-model="commitFrom.SSort" class="filter-item" placeholder="请输入排序" />
                </el-form-item>
                <el-form-item :label="$t(`table.remarks`)" prop="SMemo">
                  <el-input v-model="commitFrom.SMemo" class="filter-item" placeholder="请输入备注" />
                </el-form-item>
              </el-form>

            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-button style="margin-left: 60px" round class="filter-item" type="info" @click="cancelCommit">{{ $t('table.cancel') }}</el-button>
            <el-button v-if="calcPermission(permition, 4)" round class="filter-item" type="primary" @click="commitEdit('commitFrom')">{{ $t('table.submit') }}</el-button>
          </el-row>
        </el-card>

      </div>
    </transition>
  </div>
</template>
<script>
import { qryStatusInfo, addStatusInfo, modStatusInfo, delStatusInfo } from '@/api/baseModule'
import { qryRoleInfo } from '@/api/baseModule'
import waves from '@/directive/waves' // 水波纹指令

export default {
  name: 'StatusManage',
  directives: {
    waves
  },
  data() {
    return {
      editStatus: false,
      list: null,
      total: null,
      listLoading: true,
      tableKey: 0,
      listQuery: {
        pageIndex: 1,
        pageSize: 10
      },
      commitFrom: {
        SId: 0,
        SStatusNo: '',
        SName: '',
        SModleName: '',
        SMemo: '',
        SSort: 0
      },
      rules: {
        SStatusNo: [
          { required: true, message: '请输入编号', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        SName: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        SModleName: [
          { required: true, message: '请输入实体名称', trigger: 'blur' }
        ],
        SMemo: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ]
      },
      permition: 0
    }
  },
  created() {
    if (this.$store.state.roleInfo) {
      this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
        if (this.$route.path === item.ProgramInfo.PgUrl) {
          this.permition = item.Permition
          this.getList()
        }
      })
    } else {
      qryRoleInfo({
        rId: this.$store.getters.roles.RoleId
      }).then(response => {
        this.$store.state.roleInfo = response
        console.log(response)
        response.LsList[0].RolePrograms.forEach(item => {
          if (this.$route.path === item.ProgramInfo.PgUrl) {
            this.permition = item.Permition
            this.getList()
          }
        })
      })
    }
  },
  methods: {
    getList() {
      this.listLoading = true
      qryStatusInfo(this.listQuery).then(response => {
        this.list = response.LsList
        this.total = response.TotalRows
        this.listLoading = false
      })
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.pageIndex = val
      this.getList()
    },
    handleCreate() {
      this.editStatus = true
    },
    handleUpdate(row) {
      this.commitFrom = row
      this.editStatus = true
    },
    commitEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.commitFrom.SId > 0) {
            modStatusInfo(this.commitFrom).then(response => {
              this.getList()
              this.editStatus = false
            })
          } else {
            addStatusInfo(this.commitFrom).then(response => {
              this.getList()
              this.editStatus = false
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleDelete(row) {
      this.$alert('该操作不可逆', '您确定要删除么', {
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            delStatusInfo(row).then(response => {
              this.getList()
            })
          }
        }
      })
    },
    cancelCommit() {
      this.commitFrom = {
        SId: 0,
        SStatusNo: '',
        SName: '',
        SModleName: '',
        SMemo: '',
        SSort: 0
      }
      this.editStatus = false
    }
  }
}
</script>
